import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MemberItemIF, RewardItemIF } from './redem.interface';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-redeem',
  templateUrl: './redeem.component.html',
  styleUrls: ['./redeem.component.scss']
})
export class RedeemComponent {

  constructor(private http: HttpClient,
    private alert: AlertService
  ) {
    this.getRewards()
    this.getMemberByTel('0827813527')
  }

  memberItem!: MemberItemIF
  getMemberByTel(tel: any) {
    this.http.post(`member/search`, { Tel: parseInt(tel.value) }).subscribe({
      next: (res: any) => {
        this.memberItem = res.data
      }

    })
  }

  rewardItems!: RewardItemIF[]
  getRewards() {
    this.http.get(`reward`).subscribe({
      next: (res: any) => {
        this.rewardItems = res.data
      }
    })
  }

  redeem(item: RewardItemIF) {
    let model = {
      amountRedeem: 1,
      memberId: this.memberItem.Member_id,
      rewardId: item.ID,
      employee:'เปียวทำสอบ'
    }
    this.http.post(`redeem`, model).subscribe({
      next: (res: any) => {
        this.alert.notify(res.message, 'success')
      },
      error: (err) => {
        this.alert.notify(err.error.message, 'warning')
      }
    })
  }
}
